"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceStateAction = exports.EvidenceScreenMode = void 0;
var EvidenceScreenMode;
(function (EvidenceScreenMode) {
    EvidenceScreenMode[EvidenceScreenMode["TABLE"] = 0] = "TABLE";
    EvidenceScreenMode[EvidenceScreenMode["SPLIT"] = 1] = "SPLIT";
    EvidenceScreenMode[EvidenceScreenMode["DETAIL"] = 2] = "DETAIL";
})(EvidenceScreenMode = exports.EvidenceScreenMode || (exports.EvidenceScreenMode = {}));
var EvidenceStateAction;
(function (EvidenceStateAction) {
    EvidenceStateAction["NEW_ITEM"] = "NEW_ITEM";
    EvidenceStateAction["SHOW_ITEM"] = "SHOW_ITEM";
})(EvidenceStateAction = exports.EvidenceStateAction || (exports.EvidenceStateAction = {}));
//# sourceMappingURL=evidence-types.js.map